// The Wizard mark (SPEC §7): a share bar with the percentage. Always shown when it applies.
import { t } from "../i18n";

export function WizardShareBar({ share, filler }: { share: number; filler: boolean }) {
  const pct = Math.round((filler ? 1 : share) * 100);
  return (
    <div className="wizard-share">
      <div className="row">
        <span>{t("card.wizardShare")}</span>
        <strong>{filler ? t("river.filler") : `${pct} %`}</strong>
      </div>
      <div
        className="share-bar"
        role="meter"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-label={t("card.wizardShare")}
      >
        <span style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
